import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { INSIDER_MEMBERSHIP_PAUSE_ENABLED } from "@faire/web-api--source/indigofair/settings/INSIDER_MEMBERSHIP_PAUSE_ENABLED";
export var useSettingInsiderMembershipPauseEnabled = function() {
    return useSetting(INSIDER_MEMBERSHIP_PAUSE_ENABLED, true);
};
